import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  emailValidator,
  nameSurnameValidatorRequired,
  phoneValidatorRequired,
} from "../../../../../utilities/validators";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INTRODUCTORY_APPLICANT]: yup.object({
    [ComponentId.APPLICANT_NAME]: nameSurnameValidatorRequired,
    [ComponentId.APPLICANT_SURNAME]: nameSurnameValidatorRequired,
    [ComponentId.APPLICANT_PHONE]: phoneValidatorRequired("applicantphone"),
    [ComponentId.APPLICANT_EMAIL]: emailValidator,
  }),
};
